
const codeDict = require("@/utils/va-order-test/phoneAreaCode/areaCodes.json");

export const reformatPhone = (phoneNumber, country) => {
  const regex = /^\+([\d]{1,3})-([\d]{5,})/
  if (phoneNumber.match(regex)) {
    console.log("phone number already match +areacode-phone!")
    const match = phoneNumber.match(regex);
    return [true, match[1], match[2]]
  }   
  const tmp = phoneNumber.replace(/\D/g, '')

  if (!tmp) {
    return [true, '', '']
  }

  let resAreaCode = '';
  let resMainPhone = '';
  let resExt = '';

  if (country === 'US' || country==='CA') {
    if (tmp.length === 10) {
      resAreaCode = '1'
      resMainPhone = tmp
      return [true, resAreaCode, resMainPhone]
    }
    else if (tmp.length === 11) {
      if (tmp.slice(0,1) === '1') {
        resAreaCode = '1'
        resMainPhone = tmp.slice(1)
        return [true, resAreaCode, resMainPhone]
      } else {
        return [false, '1', tmp]
      }

    }
    else if (tmp.length > 11) {
      if (phoneNumber.includes('EXT') || phoneNumber.includes('Ext') ||
      phoneNumber.includes('ext') || phoneNumber.includes('x')) 
      {
        let phoneList = phoneNumber.split(/ext|EXT|Ext|x/)
        let pp = phoneList[0].trim()
        let ext = phoneList[1].trim()
        pp = pp.replace(/\D/g, '')
        resExt = ext.replace(/\D/g, '')
        if (pp.length === 10) {
          return [true, '1', pp, resExt]
        }
        else if (pp.length === 11) {
          return [true, '1', pp.slice(1), resExt]
        }
        else {
          return [false, '1', pp, resExt]
        }
      }
      else {
        return [false, '1', tmp]
      }
    }
    else if (tmp.length <= 4) {
      return [true, '', '']
    }
    else {
      return [false, '1', tmp]
    }
  }
  else {
    const code = codeDict[country]
    const codeLen = code ? code.length : 0;
    if (tmp.slice(0,codeLen) === codeDict[country]) {
      resAreaCode = codeDict[country]
      resMainPhone = tmp.slice(codeLen)
      return [true, resAreaCode, resMainPhone]
    }
    else if (tmp.length <= 4) {
      return [true, '', '']
    }
    else {
      if (tmp.length === 11 && tmp.slice(0,1) === '0'
        && tmp.slice(1,2) != '0' && country === "GB") {
          resAreaCode = codeDict[country]
          resMainPhone = tmp.slice(1)
          return [true, resAreaCode, resMainPhone]
        }
        else if (tmp.length === 12 && tmp.slice(0,2) === '00'
          && country === "GB") 
        {
          resAreaCode = codeDict[country]
          resMainPhone = tmp.slice(2)
          return [true, resAreaCode, resMainPhone]
        }
        else if (tmp.slice(0,2) === "00" 
          && tmp.slice(2, 2 + codeDict[country].length) === codeDict[country])
        {
          resAreaCode = codeDict[country]
          resMainPhone = tmp.slice(2 + codeDict[country].length)
          return [true, resAreaCode, resMainPhone]
        }
        else if (tmp.length === 10 && country === 'GB' && tmp.slice(0,1) != "0") {
          resAreaCode = codeDict[country]
          resMainPhone = tmp
          return [true, resAreaCode, resMainPhone]
        }
        else if (tmp.length === 11 && country === 'GB' && tmp.slice(0,1) === '1') {
          resAreaCode = codeDict[country]
          resMainPhone = tmp.slice(1)
          return [true, resAreaCode, resMainPhone]
        }
        else if (phoneNumber.split('+').length>1 && 
          phoneNumber.split('+')[1].replace(/\D/g, '').slice(0,codeLen) === codeDict[country]) 
        {
          resAreaCode = codeDict[country]
          resMainPhone = phoneNumber.split('+')[1].replace(/\D/g, '').slice(codeLen)
          return [true, resAreaCode, resMainPhone]
        }
        else {
          return [false, '1', tmp]
        }
    }
  }
}

// const phoneBook = require("/Users/yanlinwu/Documents/order_page_project/order-page/src/utils/phoneBook.json");
// const resBook = require("/Users/yanlinwu/Documents/order_page_project/order-page/src/utils/resBook.json");

// let k = 0
// let j = 0

// phoneBook.forEach((x, i) => {
//   let p = x[0]
//   let c = x[1]
//   try{
//     let res = reformatPhone(p,c)
//     if (res) {
//       if (res[0] != resBook[i]) {
//         k += 1
//         console.log(x)
//         console.log(res)
//       }
//     } 
//   } catch(e) {
//     console.log('error')
//     console.log(i)
//     console.log(x)
//   }
// })